<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" type="submit" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">        
        <h4 style="display:inline">{{editTitle}} Seguimiento {{CodigoSolicitud}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="{{tituloTipoSolicitudEx}}" />
                <!--<img class="asignada-icono" src="{{ null | IconoSolicitudAsignada}}" />-->
                <label class="codigo-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitudEx}}">{{CodigoTipoSolicitud}}</label>
                <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitudEx | IconoEstadoSolicitudEx}}" ngbTooltip="{{EstadoSolicitudExDescripcion}}" />
                <img *ngIf="IdSubTipoSolicitudEx === tercerPaisConAtestFito || IdSubTipoSolicitudEx === reExpConAtestFito || IdSubTipoSolicitudEx === canariasConAtestFito"
                     class="estado-icono-big" src="{{IdSubTipoSolicitudEx | IconoTwTcSubTipoSolicitudEx}}" container="body" ngbTooltip="{{IdSubTipoSolicitudExDescripcion}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx}}" ngbTooltip="{{IdEstadoCertificadoFitoExDescripcion}}"/>
                <img *ngIf="IdResultadoEnvioMuestrasLaboratorioEx" class="estado-icono-big" container="body" src="{{IdResultadoEnvioMuestrasLaboratorioEx | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{DescripcionIdResultadoEnvioMuestrasLaboratorioEx}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>

        <div class="row">

            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-body">

                        <div *ngIf="editMode" class="row">
                            <div class="form-group col-md-6">
                                <label class="col-form-label" for="inpCodigo">Inspector</label>
                                <input readonly formControlName="Inspector" name="Inspector" title="" class="form-control" id="inpDescripcion" type="text" value="" maxlength="50">
                            </div>
                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpFecha">Fecha</label>
                                <input readonly formControlName="Fecha" name="Fecha" title="" class="form-control" id="inpDescripcion" value="">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-3">
                                <label class="col-form-label required-field" for="inpDescripcion">Sección</label>
                                <ng-select [items]="listSeccion"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdSeccion"
                                           loadingText="Cargando..."
                                           [loading]="!(listSeccion)"
                                           [ngClass]="displayFieldCssNgSelect('IdSeccion')"
                                           notFoundText="Sección no encontrada"
                                           placeholder="-- Seleccione Sección --"
                                           clearAllText="Eliminar selección">

                                    <ng-template ng-option-tmp let-item="item">
                                        <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                    </ng-template>
                                </ng-select>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdSeccion','required')">
                                    Sección es obligatoria
                                </div>
                            </div>

                            <div class="col-md-3">
                                <label class="col-form-label required-field" for="inpDescripcion">Motivo</label>
                                <ng-select [items]="listMotivo"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdMotivo"
                                           loadingText="Cargando..."
                                           [loading]="!(listMotivo)"
                                           [ngClass]="displayFieldCssNgSelect('IdMotivo')"
                                           notFoundText="Tipo de documento no encontrado"
                                           placeholder="-- Seleccione Tipo --"
                                           clearAllText="Eliminar selección">

                                    <ng-template ng-option-tmp let-item="item">
                                        <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                    </ng-template>
                                </ng-select>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdMotivo','required')">
                                    Motivo es obligatorio
                                </div>
                            </div>

                            <div *ngIf="isInspector" class="form-group col-md-3">
                                <label class="col-form-label">Visible también para solicitante </label>
                                <p-toggleButton class="form-control-togglebutton"
                                                formControlName="VisibleSolicitante" onLabel="Sí" offLabel="NO"
                                                onIcon="pi pi-check" offIcon="pi pi-times" id=""></p-toggleButton>
                            </div>

                        </div>

                        <div class="row">

                            <div class="form-group col-md-12">
                                <label class="col-form-label required-field" for="inpCodigo">Descripción</label>

                                <textarea style="resize:none" formControlName="txtObservaciones" maxlength="500" name="txtObservaciones" title="" type="text" inputStyleClass="form-control" class="form-control" value=""></textarea>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('txtObservaciones','required')">
                                    Descripción es obligatorio
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <!--<div class="btn-group">
                    <button name="btnCleanObservacion" class="btn btn-secondary btn-sm" type="button" title="Limpia el texto introducido en observaciones" (click)="onCleanObservacion()"><i class="fa fa-eraser"></i> Limpiar</button>
                </div>-->
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</form>
